import { Component, OnInit } from '@angular/core';

import { Color } from '../uimodels/color';
import { ProgressMarker } from './marker';

export const LIGHT_BLUE = new Color(161, 211, 245);
export const BLUE = new Color(90, 178, 237);
export const BRIGHT_BLUE = new Color(20, 146, 230);
export const WHITE = new Color(255, 255, 255);

@Component({
    selector: 'progress-box',
    templateUrl: './progress-box.component.html',
    styleUrls: ['./progress-box.component.scss']
})
export class ProgressBoxComponent implements OnInit {

    markers: ProgressMarker[] = []
    private changeColorsTimer: any;

    initProgress() {
        this.markers = []
        let marker = new ProgressMarker();
        marker.color = LIGHT_BLUE;
        this.markers.push(marker);

        marker = new ProgressMarker();
        marker.color = BLUE;
        this.markers.push(marker);

        marker = new ProgressMarker();
        marker.color = BRIGHT_BLUE;
        this.markers.push(marker);

        marker = new ProgressMarker();
        marker.color = WHITE;
        this.markers.push(marker);

        marker = new ProgressMarker();
        marker.color = WHITE;
        this.markers.push(marker);

        this.changeColorsTimer = setInterval(() => {
            this.rotateColors();
        },
            500);
    }

    ngOnInit() {
        this.initProgress();
    }

    stopProgress() {
        clearInterval(this.changeColorsTimer);
    }

    getColor(marker: ProgressMarker) {
        return `rgb(${marker.color.R}, ${marker.color.G}, ${marker.color.B})`;
    }

    private rotateColors() {
        let firstWhiteAfterBlue = false;
        let blueSet = false;
        for (let marker of this.markers) {
            if (marker.color === LIGHT_BLUE) {
                marker.color = WHITE;
                continue;
            }
            if (marker.color === BLUE) {
                marker.color = LIGHT_BLUE;
                blueSet = true;
                continue;
            }
            if (marker.color === BRIGHT_BLUE) {
                marker.color = BLUE;
                firstWhiteAfterBlue = true;
                blueSet = true;
                continue;
            }
            if (marker.color === WHITE && firstWhiteAfterBlue) {
                marker.color = BRIGHT_BLUE;
                blueSet = true;
                firstWhiteAfterBlue = false;
                continue;
            }
        }

        if (!blueSet) {
            this.markers[0].color = BRIGHT_BLUE;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/progress/progress-box.component.ts